<section [attr.id]="sectionId() || null" [class]="'s__logo-section' + (background() ? ' s__bg-' + background() : '') + (cssClass() ? ' ' + cssClass() : '')">
  <div class="s__logo-section__container s__container">
    <ds-logo-block [logos]="logos()" [heading]="heading()" />
  </div>
</section>
